import { LockOutlined } from '@ant-design/icons';
import { toAbsoluteUrl } from '@app/utils/toAbsoluteUrl';
import { Button } from 'antd';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface AccessDeniedProps {
  /** Called when the user chooses to sign out / switch account. */
  onSignOut?: () => void;
  /**
   * Optional contextual message override.
   * Must already be a translated string (i.e. the output of `t()`).
   * Passing raw English text is not supported — callers are responsible for
   * translating before passing this prop.
   */
  message?: string;
}

const AccessDenied = ({ onSignOut, message }: AccessDeniedProps) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen w-screen flex flex-col items-center justify-center bg-app-primary-600 px-6 py-10">
      <img alt="Logo" src={toAbsoluteUrl('media/logos/logo_light.png')} className="h-[56px] mb-10" />

      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl px-8 py-10 flex flex-col items-center text-center">
        <div className="flex items-center justify-center h-16 w-16 rounded-full bg-red-50 mb-6">
          <LockOutlined className="text-red-500" style={{ fontSize: 28 }} />
        </div>

        <h1 className="text-2xl font-semibold text-gray-900 mb-2">{t('auth-access-denied-title')}</h1>
        <p className="text-gray-500 mb-8 leading-relaxed">{message || t('auth-access-denied-message')}</p>

        {onSignOut && (
          <Button type="primary" size="large" onClick={onSignOut} block>
            {t('auth-sign-in-different-account')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default memo(AccessDenied);
